import _ from 'lodash'

import { Carer } from 'services/legacy/carers/models'
import { NurseryClass } from 'services/legacy/rooms/models'
import { Nursery } from 'services/nurseries/models'
import { RegistrationForm } from 'services/registrationForms/models'
import { User } from 'services/users/models'

import i18n from 'translations'

export enum AllergyTypes {
  HAS_ALLERGY = 'HAS_ALLERGY',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  NO_ALLERGY = 'NO_ALLERGY',
}

export enum FamilyPosition {
  ELDEST = 'Eldest',
  MIDDLE = 'Middle',
  MULTIPLE = 'Multiple',
  ONLY_CHILD = 'Only child',
  TWIN = 'Twin',
  YOUNGEST = 'Youngest'
}

export const FAMILY_POSITIONS_OPTIONS = [
  {
    label: i18n.t('components:ChildForm:FamilyInfoForm:PositionInFamily:options:eldest'),
    value: FamilyPosition.ELDEST,
  },
  {
    label: i18n.t('components:ChildForm:FamilyInfoForm:PositionInFamily:options:middle'),
    value: FamilyPosition.MIDDLE,
  },
  {
    label: i18n.t('components:ChildForm:FamilyInfoForm:PositionInFamily:options:youngest'),
    value: FamilyPosition.YOUNGEST,
  },
  {
    label: i18n.t('components:ChildForm:FamilyInfoForm:PositionInFamily:options:onlyChild'),
    value: FamilyPosition.ONLY_CHILD,
  },
  {
    label: i18n.t('components:ChildForm:FamilyInfoForm:PositionInFamily:options:twin'),
    value: FamilyPosition.TWIN,
  },
  {
    label: i18n.t('components:ChildForm:FamilyInfoForm:PositionInFamily:options:multiple'),
    value: FamilyPosition.MULTIPLE,
  },
]

export enum FamilyMaritalStatus {
  CO_HABITING = 'co-habiting',
  DIVORCED = 'divorced',
  MARRIED = 'married',
  PARTNERS = 'partners',
  SEPARATED = 'separated',
  SINGLE = 'single',
  WIDOWED = 'widowed'
}

export const FAMILY_MARITAL_STATUS_OPTIONS = [
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:coHabiting'),
    value: FamilyMaritalStatus.CO_HABITING,
  },
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:divorced'),
    value: FamilyMaritalStatus.DIVORCED,
  },
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:married'),
    value: FamilyMaritalStatus.MARRIED,
  },
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:partners'),
    value: FamilyMaritalStatus.PARTNERS,
  },
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:separated'),
    value: FamilyMaritalStatus.SEPARATED,
  },
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:single'),
    value: FamilyMaritalStatus.SINGLE,
  },
  {
    label: i18n.t('module:Children:Constants:FamilyMaritalStatusOptions:widowed'),
    value: FamilyMaritalStatus.WIDOWED,
  },
]

export enum Gender {
  FEMALE = 'f',
  MALE = 'm',
  NON_BINARY = 'nb',
  UNKNOWN = 'u',
}

export const GENDER_OPTIONS = [
  {
    label: i18n.t('module:Children:Constants:GenderOptions:maleLabel'),
    value: Gender.MALE,
  },
  {
    label: i18n.t('module:Children:Constants:GenderOptions:femaleLabel'),
    value: Gender.FEMALE,
  },
  {
    label: i18n.t('module:Children:Constants:GenderOptions:nonBinary'),
    value: Gender.NON_BINARY,
  },
  {
    label: i18n.t('module:Children:Constants:GenderOptions:unknown'),
    value: Gender.UNKNOWN,
  },
]

export enum Languages {
  ABKHAZ = 'Abkhaz',
  AFAR = 'Afar',
  AFRIKAANS = 'Afrikaans',
  AKAN = 'Akan',
  ALBANIAN = 'Albanian',
  AMHARIC = 'Amharic',
  ARABIC = 'Arabic',
  ARAGONESE = 'Aragonese',
  ARMENIAN = 'Armenian',
  ASSAMESE = 'Assamese',
  AVARIC = 'Avaric',
  AVESTAN = 'Avestan',
  AYMARA = 'Aymara',
  AZERBAIJANI = 'Azerbaijani',
  BAMBARA = 'Bambara',
  BASHKIR = 'Bashkir',
  BASQUE = 'Basque',
  BELARUSIAN = 'Belarusian',
  BENGALI = 'Bengali',
  BIHARI = 'Bihari',
  BISLAMA = 'Bislama',
  BOSNIAN = 'Bosnian',
  BRETON = 'Breton',
  BULGARIAN = 'Bulgarian',
  BURMESE = 'Burmese',
  CANTONESE = 'Cantonese',
  CATALAN = 'Catalan; Valencian',
  CHAMORRO = 'Chamorro',
  CHECHEN = 'Chechen',
  CHICHEWA = 'Chichewa; Chewa; Nyanja',
  CHUVASH = 'Chuvash',
  CORNISH = 'Cornish',
  CORSICAN = 'Corsican',
  CREE = 'Cree',
  CROATIAN = 'Croatian',
  CZECH = 'Czech',
  DANISH = 'Danish',
  DIVEHI = 'Divehi; Dhivehi; Maldivian;',
  DUTCH = 'Dutch',
  ENGLISH = 'English',
  ESPERANTO = 'Esperanto',
  ESTONIAN = 'Estonian',
  EWE = 'Ewe',
  FAROESE = 'Faroese',
  FIJIAN = 'Fijian',
  FINNISH = 'Finnish',
  FRENCH = 'French',
  FRENCH_CREOLE = 'French Creole',
  FULA = 'Fula; Fulah; Pulaar; Pular',
  GALICIAN = 'Galician',
  GEORGIAN = 'Georgian',
  GERMAN = 'German',
  GREEK = 'Greek; Modern',
  GUARANI = 'Guaraní',
  GUJARATI = 'Gujarati',
  HAITIAN = 'Haitian; Haitian Creole',
  HAUSA = 'Hausa',
  HEBREW = 'Hebrew (modern)',
  HERERO = 'Herero',
  HINDI = 'Hindi',
  HIRI_MOTU = 'Hiri Motu',
  HUNGARIAN = 'Hungarian',
  ICELANDIC = 'Icelandic',
  IDO = 'Ido',
  IGBO = 'Igbo',
  INDONESIAN = 'Indonesian',
  INTERLINGUA = 'Interlingua',
  INTERLINGUE = 'Interlingue',
  INUKTITUT = 'Inuktitut',
  INUPIAQ = 'Inupiaq',
  IRISH = 'Irish',
  ITALIAN = 'Italian',
  JAPANESE = 'Japanese',
  JAVANESE = 'Javanese',
  KALAALLISUT = 'Kalaallisut; Greenlandic',
  KANNADA = 'Kannada',
  KANURI = 'Kanuri',
  KASHMIRI = 'Kashmiri',
  KAZAKH = 'Kazakh',
  KHMER = 'Khmer',
  KIKUYU = 'Kikuyu; Gikuyu',
  KINYARWANDA = 'Kinyarwanda',
  KIRGHIZ = 'Kirghiz; Kyrgyz',
  KIRUNDI = 'Kirundi',
  KOMI = 'Komi',
  KONGO = 'Kongo',
  KOREAN = 'Korean',
  KURDISH = 'Kurdish',
  KWANYAMA = 'Kwanyama; Kuanyama',
  LAO = 'Lao',
  LATIN = 'Latin',
  LATVIAN = 'Latvian',
  LIMBURGISH = 'Limburgish; Limburgan; Limburger',
  LINGALA = 'Lingala',
  LITHUANIAN = 'Lithuanian',
  LUBA_KATANGA = 'Luba-Katanga',
  LUGANDA = 'Luganda',
  LUXEMBOURGISH = 'Luxembourgish; Letzeburgesch',
  MACEDONIAN = 'Macedonian',
  MALAGASY = 'Malagasy',
  MALAY = 'Malay',
  MALAYALAM = 'Malayalam',
  MALTESE = 'Maltese',
  MANDARIN = 'Mandarin',
  MANX = 'Manx',
  MAORI = 'Māori',
  MARATHI = 'Marathi (Marāṭhī)',
  MARSHALLESE = 'Marshallese',
  MONGOLIAN = 'Mongolian',
  NAURU = 'Nauru',
  NAVAJO = 'Navajo; Navaho',
  NDONGA = 'Ndonga',
  NEPALI = 'Nepali',
  NORTHERN_SAMI = 'Northern Sami',
  NORTH_NDEBELE = 'North Ndebele',
  NORWEGIAN = 'Norwegian',
  NORWEGIAN_BOKMÅL = 'Norwegian Bokmål',
  NORWEGIAN_NYNORSK = 'Norwegian Nynorsk',
  NUOSU = 'Nuosu',
  OCCITAN = 'Occitan',
  OJIBWE = 'Ojibwe; Ojibwa',
  OLD_CHURCH_SLAVONIC = 'Old Church Slavonic; Church Slavic; Church Slavonic; Old Bulgarian; Old Slavonic',
  ORIYA = 'Oriya',
  OROMO = 'Oromo',
  OSSETIAN = 'Ossetian; Ossetic',
  PALI = 'Pāli',
  PANJABI = 'Panjabi; Punjabi',
  PAPIAMENTU = 'Papiamentu',
  PASHTO = 'Pashto; Pushto',
  PERSIAN = 'Persian',
  POLISH = 'Polish',
  PORTUGUESE = 'Portuguese',
  QUECHUA = 'Quechua',
  ROMANIAN = 'Romanian',
  ROMANIAN_MOLDAVIAN = 'Romanian; Moldavian; Moldovan',
  ROMANSH = 'Romansh',
  RUSSIAN = 'Russian',
  SAMOAN = 'Samoan',
  SANGO = 'Sango',
  SANSKRIT = 'Sanskrit (Saṁskṛta)',
  SARDINIAN = 'Sardinian',
  SCOTTISH_GAELIC = 'Scottish Gaelic; Gaelic',
  SERBIAN = 'Serbian',
  SHONA = 'Shona',
  SIGN_LANGUAGE = 'Sign language',
  SINDHI = 'Sindhi',
  SINHALA = 'Sinhala; Sinhalese',
  SLOVAK = 'Slovak',
  SLOVENE = 'Slovene',
  SOMALI = 'Somali',
  SOUTHERN_SOTH = 'Southern Sotho',
  SOUTH_NDEBELE = 'South Ndebele',
  SPANISH_CASTILIAN = 'Spanish; Castilian',
  SUNDANESE = 'Sundanese',
  SWAHILI = 'Swahili',
  SWATI = 'Swati',
  SWEDISH = 'Swedish',
  TAGALOG = 'Tagalog',
  TAHITIAN = 'Tahitian',
  TAJIK = 'Tajik',
  TAMIL = 'Tamil',
  TATAR = 'Tatar',
  TELUGU = 'Telugu',
  THAI = 'Thai',
  TIBETAN_STANDARD = 'Tibetan Standard; Tibetan; Central',
  TIGRINYA = 'Tigrinya',
  TONGA = 'Tonga (Tonga Islands)',
  TSONGA = 'Tsonga',
  TSWANA = 'Tswana',
  TURKISH = 'Turkish',
  TURKMEN = 'Turkmen',
  TWI = 'Twi',
  UIGHUR = 'Uighur; Uyghur',
  UKRAINIAN = 'Ukrainian',
  URDU = 'Urdu',
  UZBEK = 'Uzbek',
  VENDA = 'Venda',
  VIETNAMESE = 'Vietnamese',
  VOLAPUK = 'Volapük',
  WALLON = 'Walloon',
  WELSH = 'Welsh',
  WESTERN_FRISIAN = 'Western Frisian',
  WOLOF = 'Wolof',
  XHOSA = 'Xhosa',
  YIDDISH = 'Yiddish',
  YORUBA = 'Yoruba',
  ZHUANG = 'Zhuang; Chuang',
}

export const LANGUAGES_OPTIONS = (
  _.map(Languages, (language: string, key: string) => ({
    label: i18n.t(`module:Children:Constants:LanguagesOptions:${key.toLowerCase()}`),
    value: language,
  }))
)

interface ChildProductPriceCalculatorAssociate {
  name: string
  value: number
}

export interface ChildProductPriceCalculatorDataState {
  associations: ChildProductPriceCalculatorAssociate[]
  total: number
  value: number
}

export interface ChildProductPriceCalculatorState {
  data: ChildProductPriceCalculatorDataState
}

export interface CarerChildRelations {
  carer?: Carer
  collectionPassword?: string | null
  hasAccessToChildInParentApp?: boolean
  hasParentalResponsibility?: boolean
  id?: number
  relation?: string
  shouldReceiveDailyDiaryEmail?: boolean
  shouldReceiveNewsletterEmail?: boolean
}

export interface Child {
  ageMonths?: number
  birthDate?: Date | string
  carerChildRelations?: CarerChildRelations[]
  codeReference?: string
  displayName?: string
  ethnicity?: {
    id?: number
    name?: string
  }
  firstName?: string
  fundingCode?: string
  gender?: Gender
  id?: number
  information?: {
    address?: string
    allergies?: string
    allergiesDetails?: string
    applyPermissions?: string[]
    canBePhotographed?: boolean
    canBeTaggedInGroupPhotos?: boolean
    canConsumeFoodWithNutTraces?: boolean
    canReceiveMedicine?: boolean
    closedSocialMediaPhotoSharingPermitted?: boolean
    daytimeSleepingBehavior?: string
    dietaryReq?: string
    dietaryReqDesc?: string
    drinkingMethod?: string
    hasPermissionToBeTakenToHospital?: boolean
    id?: number
    isVegetarian?: boolean
    otherMarketingMaterialPhotoSharingPermitted?: boolean
    postcode?: string
    socialMediaPhotoSharingPermitted?: boolean
    toiletTrained?: string
    travelPermissions?: string[]
    useOnSiteMediaPermitted?: boolean
  }
  keyWorkers?: User[]
  leavingDate?: Date
  middleNames?: string
  name?: string
  nursery?: Nursery
  nurseryClass?: NurseryClass
  photo?: string
  profile?: {
    additionalInformation?: string
    attendsOtherSetting?: string
    booksPreference?: string
    childBehavior?: string
    doesReceiveEYPPFunding?: boolean
    doesReceiveTwoYearFunding?: boolean
    englishAsAdditionalLanguage?: string
    familyMaritalStatus?: FamilyMaritalStatus
    familyPosition?: FamilyPosition
    familySpokenLanguage?: string
    foodsPreference?: string
    id?: number
    isFussyEater?: boolean
    languageCapability?: string
    medicalInformation?: string
    movementCapability?: string
    otherPreference?: string
    parentsAreServingArmedForcesPersonnel?: boolean
    routine?: string
    siblings?: string
    specialEducationalNeeds?: string
    toysPreference?: string
  }
  registeredAt?: Date
  registrationForms?: RegistrationForm[]
  religion?: string | null
  startDate?: Date
  surname?: string
  taxFreeChildcareCodeReference?: string
}
